export default __webpack_public_path__ + "static/media/firework.7229d1e8.svg";